export default __webpack_public_path__ + "images/3aa7470e5f379efb51caf3e2fdea87e9-icon-logo-yourhero-round.svg";